/* PLOP_INJECT_EXPORT */
export { default as AgencyHeroWithFragment } from './agency-hero-with-fragment';
export { default as AgencyHeroWithQuery } from './agency-hero-with-query';
export { default as ContactHeroWithFragment } from './contact-hero-with-fragment';
export { default as ContactHeroWithQuery } from './contact-hero-with-query';
